import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { LandingPageModel } from '../Models/landingPageModel';
import { Http, Response, Headers, ResponseContentType, RequestMethod } from '@angular/http';
import { ActionCompanySpecificCategoryModel, AddNewActionModel, carrierFilterModel, filterModel, TracItActionCalendarSearch } from 'src/Models/TracItModel';

@Injectable({
    providedIn: 'root'
})

export class ActionItemService {
    AppUrl: string = "";
    carrierFilterModel = new carrierFilterModel();
    filterModel = new filterModel();

    constructor(private readonly _http: HttpClient, private readonly _httpdownload: Http) {
        this.setAPIUrl();
    }

    setAPIUrl() {
        if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
            this.AppUrl = sessionStorage.getItem("BaseURL") || '';
        }
    }

    getCalendarData(TokenKey: string, searchModel: TracItActionCalendarSearch): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/GetCalendarData';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(URL, searchModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    // getDashboardCalendarData(TokenKey: string, searchModel: TracItActionCalendarSearch): Observable<any> {
    //     this.setAPIUrl();
    //     let URL = this.AppUrl + 'api/ActionItem/GetDashboardCalendarData';
    //     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    //     return this._http.post<any>(URL, searchModel, httpOptions)
    //         .pipe(catchError(this.handleError));
    // }

    getDashboardCalendarData(searchModel: TracItActionCalendarSearch): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/GetDashboardCalendarData';
        return this._http.post<any>(URL, searchModel)
            .pipe(catchError(this.handleError));
    }

    // getListViewData(TokenKey: string, orderBy: any, searchModel: TracItActionCalendarSearch): Observable<any> {
    //     this.setAPIUrl();

    //     let URL = this.AppUrl + 'api/ActionItem/GetListViewData?orderBy=' + orderBy;
    //     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    //     return this._http.post<any>(URL, searchModel, httpOptions)
    //         .pipe(catchError(this.handleError));
    // }

    getListViewData(orderBy: any, searchModel: TracItActionCalendarSearch): Observable<any> {
        this.setAPIUrl();

        let URL = this.AppUrl + 'api/ActionItem/GetListViewData?orderBy=' + orderBy;
        return this._http.post<any>(URL, searchModel)
            .pipe(catchError(this.handleError));
    }

    populateActionItems(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/GetActionItems';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(URL, httpOptions)
            .pipe(catchError(this.handleError));
    }

    populateCarrierCategory(TokenKey: string): Observable<any[]> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/GetCarrierCategories';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(URL, httpOptions)
            .pipe(catchError(this.handleError));
    }

    populateActionStatus(TokenKey: string): Observable<any[]> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/GetActionStatus';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(URL, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetCarrierCategories(TokenKey: string): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetCarrierCategories';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    AddUpdateNewActionItem(TokenKey: string, addNewActionModel: AddNewActionModel): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/AddUpdateNewActionItem';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(URL, addNewActionModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetActionStatus(TokenKey: string): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionStatus';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    ActionItemSearchByIds(TokenKey: string, userId: string, updateId: string, actionId: string, briefingId: string): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/ActionItemSearchByIds/' + userId + '/' + updateId + '/' + actionId + '/' + briefingId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    ActionItemUpdateStatus(TokenKey: string, actionItemUpdateStatusModel: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/ActionItemUpdateStatus';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(fullAPIPath, actionItemUpdateStatusModel, httpOptions).pipe(catchError(this.handleError));
    }

    GetActionItemSearchStatusHistory(TokenKey: string, userId: string, updateId: string, actionId: string, briefingId: string): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemSearchStatusHistory/' + userId + '/' + updateId + '/' + actionId + '/' + briefingId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    ActionItemSaveNote(TokenKey: string, notesModel: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/ActionItemSaveNote';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(fullAPIPath, notesModel, httpOptions).pipe(catchError(this.handleError));
    }

    GetActionItemSearchNotes(TokenKey: string, userId: string, updateId: string, actionId: string, orderBy: string, briefingId: string): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemSearchNotes/' + userId + '/' + updateId + '/' + actionId + '/' + orderBy + '/' + briefingId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    ActionNotesDeleteByIds(TokenKey: string, actionNoteId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/ActionNotesDeleteByIds/' + actionNoteId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    // GetActionItemDashboardCounts(TokenKey: string, userId: any, fromDate: any, toDate: any, isFavorite: any, isMyTracIt: any): Observable<any[]> {
    //     this.setAPIUrl();
    //     let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemDashboardCounts';
    //     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    //     return this._http.post<any>(fullAPIPath, { 'userId': userId, 'fromDate': fromDate, 'toDate': toDate, 'isFavorite': isFavorite, 'isMyTracIt': isMyTracIt }, httpOptions).pipe(catchError(this.handleError));
    // }

    GetActionItemDashboardCounts(userId: any, fromDate: any, toDate: any, isFavorite: any, isMyTracIt: any): Observable<any[]> {
        this.setAPIUrl();

        const body = { 'userId': userId, 'fromDate': fromDate, 'toDate': toDate, 'isFavorite': isFavorite, 'isMyTracIt': isMyTracIt }

        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemDashboardCounts';
        return this._http.post<any>(fullAPIPath, body).pipe(catchError(this.handleError));
    }

    // GetActionItemDashboardNotes(TokenKey: string, userId: any, fromDate: any, toDate: any, isFavorite: any, isMyTracIt: any): Observable<any[]> {
    //     this.setAPIUrl();
    //     let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemDashboardNotes';
    //     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    //     return this._http.post<any>(fullAPIPath, { 'userId': userId, 'fromDate': fromDate, 'toDate': toDate, 'isFavorite': isFavorite, 'isMyTracIt': isMyTracIt }, httpOptions).pipe(catchError(this.handleError));
    // }


    GetActionItemDashboardNotes(userId: any, fromDate: any, toDate: any, isFavorite: any, isMyTracIt: any): Observable<any[]> {
        this.setAPIUrl();

        const body ={ 'userId': userId, 'fromDate': fromDate, 'toDate': toDate, 'isFavorite': isFavorite, 'isMyTracIt': isMyTracIt };

        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemDashboardNotes';        
        return this._http.post<any>(fullAPIPath, body).pipe(catchError(this.handleError));
    }


    ActionItemStateFavouriteAdd(TokenKey: string, userId: number, stateIds: string, isFavourite: number,): Observable<any> {
        this.setAPIUrl();
        this.carrierFilterModel.userID = userId;
        this.carrierFilterModel.keywordFilter = stateIds;
        this.carrierFilterModel.Status = isFavourite;

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(this.AppUrl + 'api/ActionItem/ActionItemStateFavouriteAdd', this.carrierFilterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetActionItemTypesFavoriteData(TokenKey: string, userId: number): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemTypesFavoriteData/' + userId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    ActionItemTypeFavouriteAdd(TokenKey: string, userId: number, stateIds: string, isFavourite: number): Observable<any> {
        this.setAPIUrl();
        this.carrierFilterModel.userID = userId;
        this.carrierFilterModel.keywordFilter = stateIds;
        this.carrierFilterModel.Status = isFavourite;

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(this.AppUrl + 'api/ActionItem/ActionItemTypeFavouriteAdd', this.carrierFilterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetCarrierCategoryFavoriteData(TokenKey: string, userId: number): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetCarrierCategoryFavoriteData/' + userId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    CarrierCategoryFavouriteAdd(TokenKey: string, userId: number, stateIds: string, isFavourite: number): Observable<any> {
        this.setAPIUrl();
        this.carrierFilterModel.userID = userId;
        this.carrierFilterModel.keywordFilter = stateIds;
        this.carrierFilterModel.Status = isFavourite;

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(this.AppUrl + 'api/ActionItem/CarrierCategoryFavouriteAdd', this.carrierFilterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    // GetDashboardActionItemsReuiredAttention(TokenKey: string, orderBy: string, searchModel: TracItActionCalendarSearch): Observable<any> {
    //     this.setAPIUrl();
    //     let URL = this.AppUrl + 'api/ActionItem/GetDashboardActionItemsReuiredAttention?orderBy=' + orderBy;
    //     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    //     return this._http.post<any>(URL, searchModel, httpOptions)
    //         .pipe(catchError(this.handleError));
    // }

    GetDashboardActionItemsReuiredAttention(orderBy: string, searchModel: TracItActionCalendarSearch): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/GetDashboardActionItemsReuiredAttention?orderBy=' + orderBy;
        return this._http.post<any>(URL, searchModel)
            .pipe(catchError(this.handleError));
    }

    GetLandingPageDetails(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/GetLandingPageDetails';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(URL, httpOptions)
            .pipe(catchError(this.handleError));
    }

    SaveLandingPageDetails(TokenKey: string, postModel: LandingPageModel): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/SaveUpdateLandingPageDetails';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(URL, postModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetClientFavorite(TokenKey: string, userId: any, productId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetClientFavorite/' + userId + '/' + productId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    GetActionTypesByPages(TokenKey: string, model: filterModel): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionTypesByPages';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(fullAPIPath, model, httpOptions).pipe(catchError(this.handleError));
    }

    GetActionItemTypeById(TokenKey: string, actionTypeId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemTypeById/' + actionTypeId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    AddUpdateActionItemType(TokenKey: string, actionTypeModel: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/AddUpdateActionItemType';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(fullAPIPath, actionTypeModel, httpOptions).pipe(catchError(this.handleError));
    }

    GetActionItemsType(TokenKey: string): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemsType';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    AdminAddUpdateActionItem(TokenKey: string, addNewActionModel: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/AdminAddUpdateActionItem';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(fullAPIPath, addNewActionModel, httpOptions).pipe(catchError(this.handleError));
    }

    AdminActionItemFindByPages(TokenKey: string, filterModel: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/AdminActionItemFindByPages';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(fullAPIPath, filterModel, httpOptions).pipe(catchError(this.handleError));
    }

    GetActionSearchById(TokenKey: string, actionId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionSearchById/' + actionId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    GetActionStateByActionId(TokenKey: string, actionId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionStateByActionId/' + actionId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    GetActionCarrierByActionId(TokenKey: string, actionId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionCarrierByActionId/' + actionId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    DeleteActionItemAdmin(TokenKey: string, actionId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/DeleteActionItemAdmin/' + actionId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    GetActionItemProvider(TokenKey: string): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemProvider';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    AddUpdateGeneralAlerts(TokenKey: string, generalAlertsModel: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/AddUpdateGeneralAlerts';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(fullAPIPath, generalAlertsModel, httpOptions).pipe(catchError(this.handleError));
    }

    GetGeneralAlertsFindByPages(TokenKey: string, filterModel: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetGeneralAlertsFindByPages';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(fullAPIPath, filterModel, httpOptions).pipe(catchError(this.handleError));
    }

    GetGeneralAlertsByIds(TokenKey: string, generalAlertsId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetGeneralAlertsByIds/' + generalAlertsId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    GetAdminActionItemDashboardCounts(TokenKey: string, systemUserCondition: string): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetAdminActionItemDashboardCounts/' + systemUserCondition;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    // GetActionItemSearchListForUpdateCount(TokenKey: string, userId: any): Observable<any[]> {
    //     this.setAPIUrl();
    //     let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemSearchListForUpdateCount/' + userId;
    //     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    //     return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    // }

     GetActionItemSearchListForUpdateCount(userId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/GetActionItemSearchListForUpdateCount/' + userId;
        return this._http.get<any>(fullAPIPath).pipe(catchError(this.handleError));
    }

    GetActionItemSearchListForUpdate(TokenKey: string, orderBy: string, searchModel: TracItActionCalendarSearch): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/GetActionItemSearchListForUpdate?orderBy=' + orderBy;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(URL, searchModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    DeleteActionTypes(TokenKey: string, actionTypeId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/DeleteActionTypes/' + actionTypeId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    }

    // DeleteAction(TokenKey: string, actionId: any, recurranceId: number, userId: any): Observable<any[]> {
    //     this.setAPIUrl();
    //     let fullAPIPath = this.AppUrl + 'api/ActionItem/DeleteAction/' + actionId + '/' + userId + '/' + recurranceId;
    //     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    //     return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
    // }

     DeleteAction(actionId: any, recurranceId: number, userId: any): Observable<any[]> {
        this.setAPIUrl();
        let fullAPIPath = this.AppUrl + 'api/ActionItem/DeleteAction/' + actionId + '/' + userId + '/' + recurranceId;
        return this._http.get<any>(fullAPIPath).pipe(catchError(this.handleError));
    }

    ActionGetById(TokenKey: string, actionId: any): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/ActionGetById/' + actionId;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.get<any>(URL, httpOptions)
            .pipe(catchError(this.handleError));
    }

    EditActionItem(TokenKey: string, addNewActionModel: AddNewActionModel): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/EditActionItem';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(URL, addNewActionModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    DownloadDocument(TokenKey: string, docPath: any): Observable<any> {
        this.setAPIUrl();
        let data = 'api/Jsi360/DownloadDocument';
        //const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._httpdownload.post(this.AppUrl + data, docPath, {
            method: RequestMethod.Post, responseType: ResponseContentType.Blob,
            headers: new Headers({ 'Token': TokenKey })
        }).pipe(
            map(
                (res) => {
                    return new Blob([res.blob()], { type: 'application/octet-stream' });
                }));
    }

    // ActionItemForReminderDashbaord(orderBy, searchModel: TracItActionCalendarSearch): Observable<any[]> {
    //     this.setAPIUrl();
    //     let fullAPIPath = this.AppUrl + 'api/ActionItem/ActionItemForReminderDashbaord?orderBy=' + orderBy;
    //     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    //     return this._http.post<any>(fullAPIPath, searchModel, httpOptions).pipe(catchError(this.handleError));
    // }


    ActionItemForReminderDashbaord(orderBy:string,searchModel: TracItActionCalendarSearch): Observable<any[]> {
        this.setAPIUrl();
        const fullAPIPath =
            this.AppUrl + 'api/ActionItem/ActionItemForReminderDashbaord?orderBy=' + orderBy;

        return this._http
            .post<any>(fullAPIPath, searchModel)
            .pipe(catchError(this.handleError));
    }


    private handleError(error: Response | any) {
        console.error(error.message || error);
        return observableThrowError(error.status)
    }

    GetActionItemSearchListForAllUpdates(TokenKey: string, orderBy: string, searchModel: TracItActionCalendarSearch): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/GetActionItemSearchListForAllUpdates?orderBy=' + orderBy;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(URL, searchModel, httpOptions)
            .pipe(catchError(this.handleError));
    }


    GetActionItemSearchListForAllUpdatesV2(TokenKey: string, orderBy: string, searchModel: TracItActionCalendarSearch): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/v2/GetActionItemSearchListForAllUpdates?orderBy=' + orderBy;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(URL, searchModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetActionItemSearchListForUpdateV2(TokenKey: string, orderBy: string, searchModel: TracItActionCalendarSearch): Observable<any> {
        this.setAPIUrl();
        let URL = this.AppUrl + 'api/ActionItem/v2/GetActionItemSearchListForUpdate?orderBy=' + orderBy;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._http.post<any>(URL, searchModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetUsersFindByCompanyId(TokenKey: string, companyId: any, productId: any): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/Users/GetUsersFindByCompanyId/' + companyId + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
  }
  
  GetUsersFindByCompanyIdRemoveLoginUser(TokenKey: string, companyId: any, productId: any, loginUser: any): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/Users/GetUsersFindByCompanyIdRemoveLoginUser/' + companyId + '/' + productId + '/' + loginUser;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
  }
    
  getCountry(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    let data = 'api/CountryMaster/GetCountryMaster/';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  ActionCompanySpecificCategoryAddUpdate(TokenKey: string, category: ActionCompanySpecificCategoryModel): Observable<any> {
    this.setAPIUrl();
    let data = 'api/ActionCompanySpecificCategory/ActionCompanySpecificCategoryAddUpdate/';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, category, httpOptions)
      .pipe(catchError(this.handleError));
  }

   GetAllActionCompanySpecificCategory(TokenKey: string, companyId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/ActionCompanySpecificCategory/GetAllActionCompanySpecificCategory/' + companyId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  ActionCompanySpecificCategoryDelete(TokenKey: string, categoryId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/ActionCompanySpecificCategory/ActionCompanySpecificCategoryDelete/' + categoryId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetStatesByUserID(TokenKey: any, UserID: any, productId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/IPRUpdates/GetStatesByUserID/' + UserID + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
